import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'

const LegendItem = ({ color, label }) => (
  <Stack direction="row" alignItems="center" spacing={1}>
    <Box sx={{ height: 10, width: 10, borderRadius: 5, backgroundColor: color }} />
    <Typography sx={{ fontSize: 14 }}>{label}</Typography>
  </Stack>
)

export default LegendItem
